<template>
  <div class="cards">
    <h1>Read what our clients say</h1>

    <div
      v-motion
      class="cards-info"
      :initial="{
        opacity: 0,
        y: 100,
      }"
      :visibleOnce="{
        opacity: 1,
        y: 0,
        transition: {
          delay: 100,
          stiffness: 200,
          damping: 90,
          mass: 3,
        },
      }"
    >
      <div class="card-info">
        <div>
          <img src="img/cc-card-icon.png" class="card-icon" alt="" />
        </div>
        <div>
          <p>
            HelixPay enables the ecommerce strategies I want to enable in the
            Philippines as a creator.
          </p>
        </div>
        <div class="creator-info">
          <img src="img/cc-card-info-img-spart.png" alt="" />
          <div>
            <h5>Spart</h5>
            <h6>
              <i> Content Creator </i>
            </h6>
          </div>
        </div>
      </div>

      <div class="card-info">
        <div>
          <img src="img/cc-card-icon.png" class="card-icon" alt="" />
        </div>
        <div>
          <p>
            HelixPay made it easy to launch a community membership for Pepper.ph
          </p>
        </div>
        <div class="creator-info">
          <img src="img/cc-card-info-img-dwight.png" alt="" />
          <div>
            <h5>Dwight</h5>
            <h6>
              <i> Founder, Pepper.ph </i>
            </h6>
          </div>
        </div>
      </div>

      <div class="card-info">
        <div>
          <img src="img/cc-card-icon.png" class="card-icon" alt="" />
        </div>
        <div>
          <p>
            HelixPay enables me to be more creative, since I started using the
            system I knew already that they will be my partner with my biggest
            project!
          </p>
        </div>
        <div class="creator-info">
          <img src="img/cc-card-info-img-adam.png" alt="" />
          <div>
            <h5>Adam Alejo</h5>
            <h6>
              <i> Content Creator </i>
            </h6>
          </div>
        </div>
      </div>

      <div class="card-info">
        <div>
          <img src="img/cc-card-icon.png" class="card-icon" alt="" />
        </div>
        <div>
          <p>
            We had been wanting to launch our own merch and fan club for a while
            but didnt have a good solution. HelixPay made it easy!
          </p>
        </div>
        <div class="creator-info">
          <img src="img/cc-card-info-img-awkp.png" alt="" />
          <div>
            <h5>Ang Walang Kwentang Podcast</h5>
            <h6>
              <i> Podcast </i>
            </h6>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.cards {
  width: 100%;
  padding-top: 7rem;
  padding-bottom: 7rem;
  background-color: black;
}

.cards h1 {
  margin: 0;
  text-align: center;
  color: white;
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 2rem;
}

.cards-info {
  width: 71rem;
  margin: auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
}

.card-info {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
  background-color: white;
  border-radius: 20px;
  padding: 2.5rem;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
  text-align: left;
}

.card-icon {
  width: 10%;
}

.creator-info {
  width: 70%;
  display: flex;
  gap: 1rem;
  align-items: center;
}

.creator-info img {
  width: 20%;
}

.card-info p {
  font-weight: 500;
  line-height: 1.5;
}

.card-info h5 {
  font-size: 1rem;
  font-weight: 700;
}

.card-info h6 {
  opacity: 0.6;
  font-size: 1rem;
  font-weight: 600;
}

@media only screen and (max-width: 1400px) {
  .cards-info {
    width: 60rem;
  }
}

@media only screen and (max-width: 1050px) {
  .cards-info {
    width: 40rem;
  }

  .cards-info {
    grid-template-columns: 1fr;
  }

  .cards h1 {
    font-size: 2rem;
  }
}

@media only screen and (max-width: 650px) {
  .card-info {
    justify-content: center;
    text-align: center;
  }

  .cards-info {
    width: 90%;
  }

  .creator-info {
    display: grid;
    width: 100%;
  }

  .creator-info img {
    margin: auto;
  }

  .cards h1 {
    font-size: 1.5rem;
  }
}
</style>
